import React, { useCallback, useEffect, useState, useMemo } from 'react'
import { faCheck, faFile, faFileAlt, faFilePdf, faMapMarkerAlt, faPencilAlt, faPlus } from '@fortawesome/free-solid-svg-icons';

//Components
import MainCard from '../../components/MainCard/MainCard'
import StepperVertical from '../../components/StepperVertical/StepperVertical'
import IdentificacaoPGRS from './components/IdentificacaoPGRS';
import Documentos from './components/Documentos';
import ContratosPGRS from './components/ContratosPGRS';
import Bloco from './components/Bloco';
import FichaContainerPGRS from './components/FichaContainerPGRS';

//Context
import { useAuth } from '../../context/auth';

//API
import pgrs_api from '../../api/pgrs_api';
import gerador_api from '../../api/gerador_api';

//Helpers
import { showMessage } from '../../helpers/message';
import { objCampo, validarCampos } from '../../helpers/ValidadorDeCampos';
import { transformValueFloattoFormated } from '../../helpers/formats';



function initialStatePGRS() {
    return {
        identificacao: "",
        tbFormularioPGRS_Id: "",
        statusAnalise: "Pendente",
        tbPGRSGeradorBlocos: [],
        contratosPendentes: [],
        tbPGRSGeradorDocumentos: [],
        tbPGRSAnalises: []
    }
}

export default function NovoPGRS({ btnVoltar, pgrsItem = null }) {
    const { setLoading, setupVariavel } = useAuth();

    const [gerador, setGerador] = useState(null);

    const [formularioPGRS, setFormularioPGRS] = useState(null);

    //Estado para criar/editar PGRS
    const [novoPGRS, setNovoPGRS] = useState(pgrsItem ? pgrsItem : initialStatePGRS());

    //Estado de controle para os passos do cadastro
    const [activeStep, setActiveStep] = useState(1);

    //Estado de controle dos campos preenchidos incorretamente
    const [errorsIdentificacao, setErrorsIdentificacao] = useState({});

    const [listContrato, setListContrato] = useState([]);

    const campos = [
        objCampo({ name: "identificacao", required: true }),
        objCampo({ name: "tbFormularioPGRS_Id", required: true }),
    ];

    const validateDocumentos = () => {
        let documentosObrigatorios = (formularioPGRS?.tbFormularioPGRSDocumentos ?? []).filter(doc => doc.obrigatorio)
        const todosDocumentosPresentes = documentosObrigatorios.every(obrigatorioDoc =>
            novoPGRS?.tbPGRSGeradorDocumentos?.some(doc => doc.tbFormularioPGRSDocumentos_Id === obrigatorioDoc.id)
        );
        if (documentosObrigatorios.length > 0 && !todosDocumentosPresentes) {
            showMessage("Aviso", "Existe documento obrigatório que precisa ser informado", "warning", null);
            return ["Informe todos os documentos obrigatórios para este PGRS!"];
        }
        return null;
    };

    function validateIdentificacao() {
        const _objeto = { identificacao: novoPGRS.identificacao, tbFormularioPGRS_Id: novoPGRS.tbFormularioPGRS_Id }
        const erros = validarCampos(_objeto, campos);
        const objetoDeErros = erros[0];
        if (erros[1].length > 0)
            setErrorsIdentificacao(objetoDeErros);
        return erros[1]
    }

    function validateContratos() {
        if (!gerador?.permiteContratoPGRS) return null;

        const geradorCadastra = setupVariavel?.quemCadastraContrato === "Gerador" || setupVariavel?.quemCadastraContrato === "Transportador/Gerador";

        let contratos = novoPGRS?.contratosPendentes?.filter(x => x.checked) || [];
        if ((!geradorCadastra && contratos.length === 0) || (geradorCadastra && novoPGRS?.contratosPendentes.length == 0)) {
            const mensagem = "Adicione pelo menos um contrato para seguir em frente!";
            showMessage("Aviso", mensagem, "warning", null);
            return [mensagem];
        }
        return null;
    }

    //Função para pegar os passos do cadastro/edição de geradores
    const steps = useMemo(() => {
        let baseSteps = [
            { text: "Identificação do PGRS", icon: faPencilAlt, type: "Identificação", validateStep: () => validateIdentificacao() },
            ...(formularioPGRS ?
                formularioPGRS.tbFormularioPGRSBlocos.map((bloco, index) => ({
                    text: bloco.identificacao,
                    icon: faFileAlt,
                    type: "Bloco",
                    bloco_id: bloco.id
                })) : []),
            { text: "Documentos", icon: faFilePdf, type: "Documentos", validateStep: () => validateDocumentos() }
        ];

        if (gerador?.permiteContratoPGRS) {
            baseSteps.push({ text: "Contratos", icon: faFile, type: "Contratos", validateStep: () => validateContratos() });
        }

        baseSteps.push({ text: "Finalizar", icon: faCheck, type: "Finalizar" });
        return baseSteps;
    }, [formularioPGRS, gerador, novoPGRS, setupVariavel]);

    function onChangeDocumentos(documento) {
        const _pgrs = { ...novoPGRS };
        const existeDocumento = _pgrs.tbPGRSGeradorDocumentos.findIndex(x => x.tbFormularioPGRSDocumentos_Id === documento.tbFormularioPGRSDocumentos_Id);
        if (existeDocumento === -1)
            _pgrs.tbPGRSGeradorDocumentos = [..._pgrs.tbPGRSGeradorDocumentos, { ...documento }];
        else
            _pgrs.tbPGRSGeradorDocumentos[existeDocumento] = { ..._pgrs.tbPGRSGeradorDocumentos[existeDocumento], ...documento };
        setNovoPGRS(_pgrs);
    }

    //Função para pegar o passo ativo do cadastro/edição
    function getStep() {
        const currentStep = steps[activeStep - 1];

        switch (currentStep?.type) {
            case "Identificação":
                return <IdentificacaoPGRS
                    pgrs={novoPGRS}
                    setPgrs={setNovoPGRS}
                    errors={errorsIdentificacao}
                    setErrors={setErrorsIdentificacao}
                    campos={campos}
                />;
            case "Bloco":
                const bloco = formularioPGRS.tbFormularioPGRSBlocos.filter(x => x.id == currentStep.bloco_id)[0];
                return <Bloco
                    pgrs={novoPGRS}
                    setPgrs={setNovoPGRS}
                    bloco={bloco}
                    setActiveStep={setActiveStep}
                    activeStep={activeStep}
                />;
            case "Contratos":
                return <ContratosPGRS
                    pgrs={novoPGRS}
                    setPgrs={setNovoPGRS}
                    contratosGerador={listContrato}
                    gerador={gerador}
                    setGerador={setGerador}
                />;
            case "Documentos":
                return <Documentos
                    pgrs={novoPGRS}
                    setPgrs={setNovoPGRS}
                    documentosPGRS={formularioPGRS.tbFormularioPGRSDocumentos ?? []}
                    onChangeDocumentos={onChangeDocumentos}
                />;
            case "Finalizar":
                return <FichaContainerPGRS
                    pgrs={novoPGRS}
                    finalizar={true}
                    setActiveStep={setActiveStep}
                    activeStep={activeStep}
                    onSubmit={(statusAnalise) => onSubmit(statusAnalise)}
                />;
            default:
                return null;
        }
    }

    const loadDadosGerador = () => {
        gerador_api.GetItemPGRS(novoPGRS?.id ?? "").then(response => {

            response.data.localidades = response.data.localidades.map(localidade => {
                if (localidade.localidadePadrao)
                    localidade.principal = "Sim";
                else
                    localidade.principal = "Não";

                localidade.contratos = localidade.contratos.map(contrato => {
                    Object.keys(contrato).map(key => {
                        if (!contrato[key] === null) {
                            contrato[key] = "";
                        }
                    });
                    if (novoPGRS?.contratosPendentes?.length > 0 && !!contrato.id) {
                        const _contrato = novoPGRS?.contratosPendentes.filter(x => x.id == contrato.id)[0]
                        if (!!_contrato) {
                            contrato = _contrato;
                            contrato.unidadeMedida = _contrato.volumetria;
                            contrato.contratoPendentePGRS = true;
                            contrato.checked = true;
                        }
                    } else {
                        contrato.checked = false;
                        contrato.contratoPendentePGRS = false;
                    }
                    contrato.quantidadeContratada = contrato.quantidadeContratada ? transformValueFloattoFormated(contrato.quantidadeContratada) : "";
                    return contrato;
                });
                return localidade;
            })
            setGerador(response.data);
        })
            .catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    function loadContratosGerador() {
        setLoading(true);
        gerador_api.GetListContratosAtivoPGRS(novoPGRS?.id ?? "")
            .then(response => {
                if (response.data && response.data.length > 0)
                    setListContrato(response.data)
            })
            .catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(() => setLoading(false));
    }

    function loadFormularioPGRS(tbFormularioPGRS_Id) {
        setLoading(true);
        pgrs_api.GetItem(tbFormularioPGRS_Id)
            .then(response => {
                const { data } = response;
                if (data && data.tbFormularioPGRSBlocos?.length > 0) {
                    const atualizarBlocos = data.tbFormularioPGRSBlocos.map(bloco => {
                        const blocoExistente = novoPGRS.tbPGRSGeradorBlocos?.find(x => x.tbFormularioPGRSBlocos_Id === bloco.id) || {
                            tbFormularioPGRSBlocos_Id: bloco.id,
                            bloco_descricao: bloco.bloco_Descricao
                        };
                        const atualizarQuestoes = bloco.tbFormularioPGRSBlocoQuestoes.map(questao => {
                            const questaoExistente = blocoExistente.tbPGRSGeradorBlocoQuestos?.find(x => x.tbFormularioPGRSBlocoQuestoes_Id === questao.id) || {};
                            return {
                                ...questaoExistente,
                                tbFormularioPGRSBlocoQuestoes_Id: questao.id,
                                valor: questaoExistente.valor || "",
                                obrigatorio: questao.obrigatorio,
                                sequencia: questao.sequencia,
                                descricao: questao.descricao,
                                tipoValor: questao.tipoValor,
                                tbFormularioPGRSBlocoQuestaoOpcoes: questao.tbFormularioPGRSBlocoQuestaoOpcoes || []
                            };
                        });
                        return {
                            ...blocoExistente,
                            tbPGRSGeradorBlocoQuestos: atualizarQuestoes
                        };
                    });
                    setNovoPGRS({ ...novoPGRS, tbPGRSGeradorBlocos: atualizarBlocos });
                    setFormularioPGRS(data);
                } else {
                    showMessage("Aviso", "Aviso, Nenhum formulário PGRS disponível para responder.", "warning", btnVoltar);
                }
            })
            .catch(e => showMessage("Error", e.message, "error", null))
            .finally(() => setLoading(false));
    }

    async function onSubmit() {
        let _pgrs = { ...novoPGRS };
        _pgrs.statusAnalise = setupVariavel?.analisePGRS ? "Aguardando Análise" : "Aprovado Automaticamente";

        const geradorCadastra = setupVariavel?.quemCadastraContrato === "Gerador" || setupVariavel?.quemCadastraContrato === "Transportador/Gerador";

        if (gerador?.permiteContratoPGRS) {
            if (!geradorCadastra) {
                _pgrs.contratosPendentes = [..._pgrs.contratosPendentes.filter(x => x.checked).map(item => {
                    item.quantidadeContratada = item?.quantidadeContratada.toString().replace(",", ".")
                    return item;
                })];
            }
            else
                _pgrs.contratosPendentes = [..._pgrs.contratosPendentes.map(item => {
                    item.quantidadeContratada = item?.quantidadeContratada.toString().replace(",", ".")
                    return item;
                })];
        } else {
            _pgrs.contratosPendentes = [];
        }

        _pgrs.tbPGRSAnalises = [{ status: "Editado pelo Gerador", observacoes: "Editado pelo Gerador" }]

        let _documentos = [...novoPGRS.tbPGRSGeradorDocumentos];
        delete _pgrs.tbPGRSGeradorDocumentos;

        setLoading(true);

        try {
            let res;
            if (!_pgrs.id) {
                res = await pgrs_api.InsertPGRSGerador(_pgrs);
                _documentos = _documentos.map(doc => ({
                    ...doc,
                    tbPGRSGerador_Id: res.data.id
                }));
                await pgrs_api.PostDocumentos(_documentos);
                showMessage("Sucesso", "PGRS cadastrado com sucesso", "success", btnVoltar);
            } else {
                res = await pgrs_api.UpdatePGRSGerador(_pgrs);
                _documentos = _documentos.map(doc => ({
                    ...doc,
                    tbPGRSGerador_Id: res.data.id
                }));
                await pgrs_api.PostDocumentos(_documentos);
                showMessage("Sucesso", "PGRS cadastrado com sucesso", "success", btnVoltar);
            }
        } catch (error) {
            const message = error.message ? error.message || "Erro ao conectar com API" : "Erro ao conectar com API";
            showMessage("Erro", message, "error");
        } finally {
            setLoading(false);
        }
    }


    useEffect(() => {
        loadDadosGerador();
    }, []);

    useEffect(() => {
        const naoEGerador = setupVariavel?.quemCadastraContrato !== "Gerador" && setupVariavel?.quemCadastraContrato !== "Transportador/Gerador";
        if (gerador?.permiteContratoPGRS === true && naoEGerador) {
            loadContratosGerador();
        }
    }, [gerador?.permiteContratoPGRS, setupVariavel?.quemCadastraContrato]);

    useEffect(() => {
        if (!!novoPGRS.tbFormularioPGRS_Id) {
            loadFormularioPGRS(novoPGRS.tbFormularioPGRS_Id);
        }
    }, [novoPGRS.tbFormularioPGRS_Id]);

    useEffect(() => {
        if (formularioPGRS && gerador) {
            if ((formularioPGRS.tbFormularioPGRSModalidades ?? []).length === 0) {
                showMessage(
                    "Atenção",
                    "O formulário atual não possui modalidades cadastradas. Por favor, entre em contato com a secretaria responsável para resolver a situação.",
                    "warning",
                    btnVoltar
                );
                return;
            }

            const tiposColetaDoFormulario = formularioPGRS.tbFormularioPGRSModalidades.map(modalidade => modalidade.tbTipoColeta_Id.toString()) ?? [];

            if (setupVariavel?.quemCadastraContrato !== "Gerador") {
                let _listaContrato = listContrato.filter(x => tiposColetaDoFormulario.includes(x.tbTipoColeta_Id.toString()));
                setListContrato(_listaContrato)
            } else {
                const _gerador = { ...gerador };
                _gerador.localidades = _gerador.localidades.map(local => {
                    const filtroContratos = local.contratos.filter(contrato =>
                        tiposColetaDoFormulario.includes(contrato.tbTipoColeta_Id.toString())
                    );
                    return {
                        ...local,
                        contratos: filtroContratos,
                    };
                });
                const hasChanged = JSON.stringify(_gerador.localidades) !== JSON.stringify(gerador.localidades);
                if (hasChanged)
                    setGerador(_gerador);
            }
        }
    }, [formularioPGRS, gerador, setupVariavel]);

    return (
        <MainCard noCard btnVoltar={btnVoltar}>
            {steps.length > 0 &&
                <StepperVertical
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                    steps={steps}
                    onSubmit={onSubmit}
                    hideButton={steps[activeStep - 1].type == "Bloco" || steps[activeStep - 1].type == "Finalizar" ? true : false}
                >
                    {getStep()}
                </StepperVertical>}
        </MainCard >
    )
}
